/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { IncidentOperation } from '@/api/operations/models/incident-operation'

@Component
export class IncidentOperationGuardMixin extends Vue {
    /// GUARD OPERATIONS ///

    $_canCreateIncident(): boolean {
        return this.$_hasOperationInCurrentLaboratory(IncidentOperation.CREATE)
    }
    $_canPrintIncident(): boolean {
        return this.$_hasOperationInCurrentLaboratory(IncidentOperation.PRINT)
    }

    /// CAN BE ///

    $_canBeIncidentPrinted(incident: any): boolean {
        return incident?.incidentType?.canBePrinted
    }
}
